import { machineStatusApi } from '../../api/machineStatusApi'

import { machineStatusSignal, machineStatusLoadedSignal, machineStatusErrorSignal } from '../signals/machineStatusSignals'

export const fetchMachineStatus = async (businessEntityId, machinePermanentId, config, accessToken, signal = null) => {
    machineStatusLoadedSignal.value = false
    machineStatusSignal.value = null
    return await machineStatusApi.fetchMachineStatus(businessEntityId, machinePermanentId, config, accessToken, signal).then(
        (machineStatus) => {
            machineStatusSignal.value = machineStatus
            machineStatusLoadedSignal.value = true
            return machineStatusSignal.value
        }
    ).catch(
        (err) => {
            machineStatusErrorSignal.value = err
            throw err
        }
    )
}